import React from 'react';
import './suggestion.layout.sass';
import SubHeaderComponent from "../../components/subHeader/subHeader.component";
import suggImg from '../../assets/image/suggestion.png';
import {Form, Col, Row, Button, Schema, FormGroup, FormControl, ControlLabel, Alert} from "rsuite";
import Axios from 'axios';
import {Setting} from "../../setting";

class SuggestionLayout extends React.Component{

    constructor(props) {
        super(props);
        this.state ={
            loading : false,
            formValue : {
                name : '',
                email: '',
                mobile: '',
                msg : '',
            }
        }
    }

    render() {
        const {StringType, NumberType} = Schema.Types;

        const model = Schema.Model({
            name: StringType().isRequired('نام و نام خانوادگی شما اجباری است'),
            mobile: NumberType()
                .isRequired('وارد کردن شماره تلفن همراه اجباری است'),
            email: StringType()
                .isEmail('لطفا یک ایمیل معتبر وارد کنید، یا خالی بگذارید'),
            msg: StringType().isRequired('نوشتن پیام، اجباری است.')
        });

        const handleSubmit = (value) => {
            if(value){
                this.setState({loading: true});
                Axios.post(`${Setting.apiUrl}api/cristicRecommend` ,
                    this.state.formValue ,
                    {Accept: "application.json", contentType: "application.json"}
                    )
                    .then(res =>{
                        this.setState({
                            loading: false
                        });
                       if (res.status === 200 ){
                           Alert.success('پیام شما با موفقیت ارسال شد');
                           this.setState({
                               formValue : {
                                   name : '',
                                   email: '',
                                   mobile: '',
                                   msg : '',
                               }
                           })
                       }  else {
                           Alert.error('خطایی در برقراری ارتباط به وجود آمده است لطفا دباره تلاش کنید')
                       }
                    }).catch(error => {
                        Alert.error(error);
                        this.setState({loading: false});
                    })
            }
        };

        return (
            <div>
                <SubHeaderComponent pageName='انتقادات و پیشنهادات' imageSrc={suggImg}/>
                <div className='suggest-main'>
                    <div className='suggest-from-div'>
                        <div className='suggest-title'>
                            <li><span>انتقادات و پیشنهادات</span></li>
                        </div>
                        <div className='suggest-form-area'>
                            <Form formValue={this.state.formValue} onChange={(value)=>{
                                this.setState({formValue: value})
                            }}
                                  model={model} onSubmit={(value) => handleSubmit(value)} className='suggest-form'>
                                <Row style={{marginBottom: '24px'}}>
                                    <Col sm={12} xs={24}>
                                        <FormGroup>
                                            <ControlLabel className='suggest-form-label'>تلفن همراه</ControlLabel>
                                            <FormControl className='suggest-form-input' size='lg' name='mobile'
                                                         placeholder='اجباری'/>
                                        </FormGroup>
                                    </Col>
                                    <Col sm={12} xs={24}>
                                        <FormGroup>
                                            <ControlLabel className='suggest-form-label'>نام و
                                                نام‌خانوادگی</ControlLabel>
                                            <FormControl className='suggest-form-input' size='lg' name='name'
                                                         placeholder='اجباری'/>
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <FormGroup>
                                    <ControlLabel className='suggest-form-label'>پست الکترونیک</ControlLabel>
                                    <FormControl className='suggest-form-input' size='lg' name='email'
                                                 placeholder='اختیاری'/>
                                </FormGroup>
                                <FormGroup>
                                    <ControlLabel className='suggest-form-label'>پیام شما</ControlLabel>
                                    <FormControl className='suggest-form-input' size='lg' componentClass='textarea'
                                                 row={2} name='msg' placeholder='اجباری'/>
                                </FormGroup>
                                <Button loading={this.state.loading} className='suggest-submit-btn' type='submit'>ارسال</Button>
                            </Form>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default SuggestionLayout;